import React, { type RefObject } from 'react';
import { useTableOfContents } from '../../hooks/useTableOfContents';
import styles from './DocTableOfContents.module.css';

interface DocTableOfContentsProps {
  scrollContainerRef: RefObject<HTMLDivElement | null>;
}

export const DocTableOfContents: React.FC<DocTableOfContentsProps> = ({
  scrollContainerRef,
}) => {
  const { entries, activeId } = useTableOfContents(scrollContainerRef);

  if (entries.length === 0) return null;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const container = scrollContainerRef.current;
    if (!container) return;

    const target = container.querySelector(`#${CSS.escape(id)}`);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.label}>On this page</div>
      <ul className={styles.list}>
        {entries.map((entry) => (
          <li
            key={entry.id}
            className={`${styles.item} ${activeId === entry.id ? styles.active : ''}`}
          >
            <a
              href={`#${entry.id}`}
              className={`${styles.link} ${entry.level === 3 ? styles.linkH3 : ''}`}
              onClick={(e) => handleClick(e, entry.id)}
            >
              {entry.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
